const $$splitComponentImporter = () => import('/build/web/src/routes/_authenticated/chat-records/records/$request_id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
// SUNSET: Deprecated as primary entry — kept for shareable deep links only.
//
// Under v5 architecture, the primary entry for a single-call detail is
// L3a /chat-records/sessions/:sk/calls/:request_id (added in Epic E).
// L3b /chat-records/sessions/:sk/turns/:turn_id renders one
// <CallDetailBlock/> per call in the turn (Epic D + E).  This
// /records/:request_id route stays as a thin shell so existing bookmarks
// / shared links / external pasted URLs keep working — Epic D3 reduced
// the body to just <CallDetailBlock/> with sticky sidebar.
//
// Delete when: no referrer hits this route except direct-share traffic
// for 3 months (run access-log audit before removing).
// Review by: 2026-09.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth-store';
import { ROLE } from '@/lib/roles';
// Breadcrumb component owns its own useChatRecordDetail() call.  React
// Query dedups by queryKey (chatRecordsKeys.detail(requestId)), so this
// shares the in-flight request and cache with CallDetailBlock — no
// duplicate network round-trip.
//
// R3-5: link path uses the backend-returned `session_key` directly; the
// old client-side EncodeSessionKey mirror was deleted in Epic D3 so
// there's no risk of cross-language drift.

export const Route = createFileRoute('/_authenticated/chat-records/records/$request_id')({
  beforeLoad: () => {
    const auth = useAuthStore.getState().auth;
    if (!auth.user || auth.user.role < ROLE.ADMIN) {
      throw redirect({
        to: '/403'
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});